(() => {
  if (typeof window.FaraCartButton?.prepare === 'function') { window.FaraCartButton.prepare(); return; }
  const pending = new WeakSet();
  let notice, noticeSequence = 0, navigationSequence = 0, countSequence = 0;
  const labels = (() => { try { return JSON.parse(document.getElementById('FaraCartLabels')?.textContent || '{}'); } catch { return {}; } })();
  const shopRoot = () => window.Shopify?.routes?.root || '/';
  const localUrl = value => {
    try { const url = new URL(value, location.href); return url.origin === location.origin && /^https?:$/.test(url.protocol) ? url : null; } catch { return null; }
  };
  const productUrl = value => {
    const url = localUrl(value);
    if (!url || /%2f|%5c/i.test(url.pathname)) return null;
    const prefix = [shopRoot() + 'products/', '/products/'].find(prefix => url.pathname.startsWith(prefix));
    if (!prefix || !/^[a-z0-9][a-z0-9-]*\/?$/i.test(url.pathname.slice(prefix.length))) return null;
    return url;
  };
  const phrase = (root, key, title = '') => {
    const dataKey = {adding_title: 'addingLabel', added_title: 'addedLabel', error: 'errorLabel', view_bag: 'bagLabel', dismiss: 'dismissLabel'}[key];
    return (root?.dataset[dataKey] || labels[key] || '').replace('__title__', title).replace(/\s+/g, ' ').trim();
  };
  function closeNotice() { noticeSequence++; if (notice) notice.hidden = true; }
  function announce(root, message, state, attempt) {
    if (attempt !== noticeSequence) return;
    if (!notice) {
      notice = document.createElement('div'); notice.className = 'fara-cart-notice'; notice.hidden = true;
      const messageNode = document.createElement('p'); messageNode.dataset.cartMessage = '';
      const actions = document.createElement('div'); actions.className = 'fara-cart-notice__actions';
      const bag = document.createElement('a'); bag.dataset.cartBag = '';
      const dismiss = document.createElement('button'); dismiss.type = 'button'; dismiss.dataset.cartDismiss = '';
      actions.append(bag, dismiss); notice.append(messageNode, actions); document.body.append(notice);
    }
    const host = root?.closest?.('dialog[open]') || document.body;
    if (notice.parentElement !== host) host.append(notice);
    notice.setAttribute('role', state === 'error' ? 'alert' : 'status'); notice.setAttribute('aria-live', state === 'error' ? 'assertive' : 'polite');
    notice.classList.toggle('is-error', state === 'error');
    const bag = notice.querySelector('[data-cart-bag]');
    const bagUrl = localUrl(root?.dataset.cartUrl || shopRoot() + 'cart');
    bag.hidden = state === 'pending' || !bagUrl;
    if (bagUrl) bag.href = bagUrl.href;
    bag.textContent = phrase(root, 'view_bag');
    notice.querySelector('[data-cart-dismiss]').textContent = phrase(root, 'dismiss');
    notice.hidden = false;
    notice.querySelector('[data-cart-message]').textContent = message;
  }
  async function refreshCount() {
    const attempt = ++countSequence;
    try {
      const endpoint = localUrl(shopRoot() + 'cart.js');
      if (!endpoint) return;
      const response = await fetch(endpoint.href, {credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'application/json'}});
      if (!response.ok) return;
      const cart = await response.json();
      if (attempt !== countSequence || !Number.isSafeInteger(cart.item_count) || cart.item_count < 0) return;
      if (typeof window.FaraCartCount?.update === 'function') window.FaraCartCount.update(cart.item_count);
      else document.querySelectorAll('[data-fara-cart-count]').forEach(node => { node.textContent = `(${cart.item_count})`; });
    } catch {}
  }
  function addEndpoint(value) {
    const url = localUrl(value);
    if (!url || !/\/cart\/add(?:\.js)?$/.test(url.pathname)) return null;
    url.pathname = url.pathname.replace(/(?:\.js)?$/, '.js'); url.search = ''; url.hash = '';
    return url.href;
  }
  async function post(endpoint, body) {
    const response = await fetch(endpoint, {method: 'POST', credentials: 'same-origin', headers: {Accept: 'application/json'}, body});
    const data = await response.json();
    if (!response.ok || data.status || !data.id && !data.items?.length) {
      const error = new Error();
      if (typeof data.description === 'string') error.publicMessage = data.description;
      throw error;
    }
    return data;
  }
  async function run(control, root, resolveProduct) {
    if (pending.has(control) || control.disabled || control.getAttribute('aria-disabled') === 'true') return;
    pending.add(control);
    const attempt = ++noticeSequence, page = location.href, navigation = navigationSequence;
    const originalLabel = control.getAttribute('aria-label'), originalTitle = control.getAttribute('title');
    const wasDisabled = Boolean(control.disabled);
    if (control.tagName === 'BUTTON') control.disabled = true;
    control.setAttribute('aria-disabled', 'true'); control.setAttribute('aria-busy', 'true');
    let title = control.dataset.cartTitle || '', didPost = false;
    const loading = phrase(root, 'adding_title', title);
    if (loading) {control.setAttribute('aria-label', loading); control.setAttribute('title', loading);}
    announce(root, loading, 'pending', attempt);
    try {
      let endpoint, body;
      if (resolveProduct) {
        const url = productUrl(control.dataset.faraCartProductUrl);
        if (!url) throw new Error();
        const jsonUrl = new URL(url.href); jsonUrl.pathname = jsonUrl.pathname.replace(/\/$/, '') + '.js'; jsonUrl.search = ''; jsonUrl.hash = '';
        const response = await fetch(jsonUrl.href, {credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'application/json'}});
        if (!response.ok || response.url && !localUrl(response.url)) throw new Error();
        const product = await response.json();
        if (!Array.isArray(product.variants) || !product.variants.length) throw new Error();
        if (navigation !== navigationSequence || page !== location.href || !control.isConnected) return;
        title = typeof product.title === 'string' ? product.title : title;
        if (product.variants.length !== 1) {
          if (attempt !== noticeSequence) return;
          closeNotice();
          if (typeof window.FaraRadioNavigation?.navigate === 'function') window.FaraRadioNavigation.navigate(url);
          else location.assign(url.href);
          return;
        }
        const variant = product.variants[0];
        if (!variant.available) {const error = new Error(); error.publicMessage = phrase(root, 'unavailable_title', title); throw error;}
        if (!/^\d+$/.test(String(variant.id))) throw new Error();
        endpoint = addEndpoint(shopRoot() + 'cart/add.js');
        body = new FormData(); body.set('id', String(variant.id)); body.set('quantity', '1');
      } else {
        const form = control.closest('form[data-fara-artwork-cart]');
        endpoint = addEndpoint(form?.getAttribute('action'));
        body = new FormData(form);
      }
      if (!endpoint) throw new Error();
      didPost = true;
      await post(endpoint, body);
      if (control.isConnected) announce(root, phrase(root, 'added_title', title), 'success', attempt);
    } catch (error) {
      if (control.isConnected) announce(root, error.publicMessage || phrase(root, 'error'), 'error', attempt);
    } finally {
      if (didPost) refreshCount();
      pending.delete(control);
      if (control.tagName === 'BUTTON') control.disabled = wasDisabled;
      control.removeAttribute('aria-disabled'); control.removeAttribute('aria-busy');
      if (originalLabel == null) control.removeAttribute('aria-label'); else control.setAttribute('aria-label', originalLabel);
      if (originalTitle == null) control.removeAttribute('title'); else control.setAttribute('title', originalTitle);
    }
  }
  function prepare(scope = document) {
    scope.querySelectorAll('.fara-inline-record__art').forEach(art => {
      if (art.querySelector('[data-fara-cart-control],[data-fara-cart-product-url]')) return;
      const link = Array.from(art.children).find(child => child.matches('a[href]') && productUrl(child.getAttribute('href')));
      if (!link) return;
      const title = art.closest('.fara-inline-record')?.querySelector('h3')?.textContent?.trim() || link.getAttribute('aria-label') || link.querySelector('img')?.alt || '';
      const wrapper = document.createElement('div'); wrapper.className = 'fara-cart-control'; wrapper.dataset.faraCartControl = '';
      const button = document.createElement('a'); button.className = 'fara-cart-button'; button.href = link.href;
      button.dataset.faraCartProductUrl = link.href; button.dataset.cartTitle = title;
      button.dataset.noRouter = '';
      button.setAttribute('aria-label', phrase(wrapper, 'add_title', title)); button.title = phrase(wrapper, 'add_title', title);
      button.innerHTML = '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 3h2l2.4 12h10.9l2-8H6"/><circle cx="9" cy="20" r="1"/><circle cx="17" cy="20" r="1"/></svg>';
      wrapper.append(button); art.append(wrapper);
    });
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (event.defaultPrevented || !form.matches?.('form[data-fara-artwork-cart]') || !form.isConnected) return;
    event.preventDefault();
    const control = form.querySelector('button[name=add]'), root = form.closest('[data-fara-cart-control]');
    if (control) run(control, root, false);
  });
  document.addEventListener('click', event => {
    if (event.target.closest?.('[data-cart-dismiss]')) {closeNotice(); return;}
    const control = event.target.closest?.('[data-fara-cart-product-url]');
    if (!control || !control.isConnected || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (control.tagName === 'A' && (control.target && control.target !== '_self' || control.hasAttribute('download'))) return;
    event.preventDefault();
    run(control, control.closest('[data-fara-cart-control]'), true);
  }, true);
  window.addEventListener('fara:before-navigate', () => {navigationSequence++; closeNotice();});
  window.addEventListener('pagehide', () => {navigationSequence++; closeNotice();});
  document.addEventListener('shopify:section:load', () => prepare());
  document.addEventListener('fara:preview-prepare', () => prepare());
  window.FaraCartButton = {prepare};
  prepare();
})();
